<template>
  <section
    class="viewsrhqyBasicManage_beidouApiConfig p-4 h-full box-border overflow-y-auto"
  >
    <viewTitle title="业务管理 / 北斗接口配置" :showReturn="false" />
    <div class="mt-4 mb-4 space-x-2">
      <el-button
        v-has="['c-base-mp-beidou-config-save']"
        size="small"
        type="primary"
        @click="openDialog()"
      >新 增</el-button>
      <el-button size="small" @click="loadData">刷 新</el-button>
    </div>

    <el-table border size="small" :data="dataSource" v-loading="loading">
      <el-table-column label="配置名称" prop="name" min-width="140">
        <template slot-scope="{ row }">{{ row.name || '-' }}</template>
      </el-table-column>
      <el-table-column label="接口地址" prop="beidou_url" min-width="220" />
      <el-table-column label="账号" prop="beidou_user_name" min-width="140" />
      <el-table-column label="Client ID" prop="beidou_client_id" min-width="140" />
      <el-table-column label="关联预约业务" min-width="220">
        <template slot-scope="{ row }">
          {{ formatBusinessNames(row.business_names) }}
        </template>
      </el-table-column>
      <el-table-column label="最后修改人" prop="update_by_name" min-width="120">
        <template slot-scope="{ row }">{{ row.update_by_name || '-' }}</template>
      </el-table-column>
      <el-table-column label="最后修改时间" min-width="160">
        <template slot-scope="{ row }">{{ formatTime(row.update_time) }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="210">
        <template slot-scope="{ row }">
          <el-button
            v-has="['c-base-mp-beidou-config-save']"
            type="text"
            size="small"
            @click="openDialog(row)"
          >编辑</el-button>
          <el-button
            v-has="['c-base-mp-beidou-config-validate']"
            type="text"
            size="small"
            @click="onValidate(row)"
          >验证</el-button>
          <el-button
            v-has="['c-base-mp-beidou-config-delete']"
            type="text"
            size="small"
            class="text-red-500"
            @click="onDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="form.id ? '编辑北斗接口配置' : '新增北斗接口配置'"
      :visible.sync="dialogVisible"
      width="720px"
      @close="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="配置名称" prop="name">
          <el-input
            class="w-full"
            clearable
            placeholder="请输入配置名称"
            v-model.trim="form.name"
          />
        </el-form-item>
        <el-form-item label="接口地址" prop="beidou_url">
          <el-input
            class="w-full"
            clearable
            placeholder="请输入北斗接口地址"
            v-model.trim="form.beidou_url"
          />
        </el-form-item>
        <el-form-item label="账号" prop="beidou_user_name">
          <el-input
            class="w-full"
            clearable
            placeholder="请输入北斗账号"
            v-model.trim="form.beidou_user_name"
          />
        </el-form-item>
        <el-form-item label="密码" prop="beidou_password">
          <el-input
            class="w-full"
            clearable
            show-password
            placeholder="请输入北斗密码，编辑时留空则不修改"
            v-model="form.beidou_password"
          />
        </el-form-item>
        <el-form-item label="Client ID" prop="beidou_client_id">
          <el-input
            class="w-full"
            clearable
            placeholder="请输入北斗Client ID"
            v-model.trim="form.beidou_client_id"
          />
        </el-form-item>
        <el-form-item label="API Key" prop="beidou_key">
          <el-input
            class="w-full"
            clearable
            show-password
            placeholder="请输入北斗API Key，编辑时留空则不修改"
            v-model="form.beidou_key"
          />
        </el-form-item>
        <el-form-item label="关联预约业务" prop="business_ids">
          <el-select
            class="w-full"
            multiple
            filterable
            collapse-tags
            placeholder="请选择关联一级预约业务"
            v-model="form.business_ids"
          >
            <el-option
              v-for="item in businessOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :maxlength="100"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="form.remark"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          v-has="['c-base-mp-beidou-config-save']"
          size="small"
          type="primary"
          @click="onSave"
        >保 存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";

const defaultForm = () => ({
  id: "",
  name: "",
  beidou_url: "",
  beidou_user_name: "",
  beidou_password: "",
  beidou_client_id: "",
  beidou_key: "",
  business_ids: [],
  remark: ""
});

export default {
  data() {
    return {
      dataSource: [],
      businessOptions: [],
      dialogVisible: false,
      loading: false,
      validateLoading: false,
      form: defaultForm(),
      rules: {
        beidou_url: [
          { required: true, message: "请输入北斗接口地址", trigger: "blur" }
        ],
        beidou_user_name: [
          { required: true, message: "请输入北斗账号", trigger: "blur" }
        ],
        beidou_password: [
          {
            validator: (rule, value, callback) => {
              if (this.form.id && !value) {
                callback();
                return;
              }
              if (!value) {
                callback(new Error("请输入北斗密码"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        beidou_client_id: [
          { required: true, message: "请输入北斗Client ID", trigger: "blur" }
        ],
        beidou_key: [
          {
            validator: (rule, value, callback) => {
              if (this.form.id && !value) {
                callback();
                return;
              }
              if (!value) {
                callback(new Error("请输入北斗API Key"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        business_ids: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请选择关联预约业务",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 查询北斗账号配置列表。
     */
    async loadData() {
      this.loading = true;
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/query_beidou_api_config"
        });
        const data = (dataObj.data && dataObj.data.data) || [];
        this.dataSource = Array.isArray(data) ? data : [];
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    /**
     * 查询当前基地一级预约业务，用于北斗账号业务绑定。
     */
    async loadBusinessOptions() {
      const dataObj = await this.$common.http({
        url: "/api/queue/admin/query_business",
        data: { state: 1, keyword: "", page_size: 999 }
      });
      const pageData = (dataObj.data && dataObj.data.data) || {};
      const rows = pageData.data || pageData || [];
      this.businessOptions = Array.isArray(rows) ? rows : [];
    },
    /**
     * 打开新增或编辑弹窗，并清理敏感字段脱敏值。
     */
    openDialog(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        const form = defaultForm();
        if (row) {
          Object.assign(form, row, {
            beidou_password: row.beidou_password || "",
            beidou_key: row.beidou_key || "",
            business_ids: Array.isArray(row.business_ids)
              ? [...row.business_ids]
              : []
          });
        }
        this.form = form;
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    /**
     * 保存北斗账号配置，敏感字段留空时由后端保留旧值。
     */
    onSave() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        this.$confirm("确认保存北斗接口配置?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          const form = { ...this.form };
          if (this.isMaskedSecret(form.beidou_password)) {
            form.beidou_password = "";
          }
          if (this.isMaskedSecret(form.beidou_key)) {
            form.beidou_key = "";
          }
          await this.$common.http({
            url: "/api/queue/admin/save_beidou_api_config",
            data: form
          });
          this.$message.success("保存成功！");
          this.dialogVisible = false;
          this.loadData();
        });
      });
    },
    /**
     * 删除指定北斗账号配置。
     */
    onDelete(row) {
      this.$confirm("确认删除该北斗接口配置？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await this.$common.http({
          url: "/api/queue/admin/delete_beidou_api_config",
          data: { id: row.id }
        });
        this.$message.success("删除成功！");
        this.loadData();
      });
    },
    /**
     * 验证指定账号配置，通过获取车辆坐标验证接口可用性。
     */
    async onValidate(row) {
      if (this.validateLoading) {
        return;
      }
      try {
        const promptResult = await this.$prompt(
          "请输入需要验证的车牌号",
          "北斗接口验证",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputPlaceholder: "请输入车牌号",
            inputValidator: value => {
              if (!String(value || "").trim()) {
                return "请输入需要验证的车牌号";
              }
              return true;
            }
          }
        );
        const plate_no = String((promptResult && promptResult.value) || "").trim();
        if (!plate_no) {
          return;
        }
        const plate_no_type = await this.selectPlateType();
        if (!plate_no_type) {
          return;
        }
        this.validateLoading = true;
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/validate_beidou_api_config",
          data: {
            id: row.id,
            plate_no,
            plate_no_type
          }
        });
        const message =
          (dataObj.data.data && dataObj.data.data.message) || "验证成功！";
        this.$message.success(message);
      } catch (error) {
      } finally {
        this.validateLoading = false;
      }
    },
    /**
     * 选择车牌颜色，返回北斗接口需要的车牌颜色类型。
     */
    async selectPlateType() {
      try {
        await this.$msgbox({
          title: "车牌颜色",
          message:
            '<div style="padding:8px 0"><label style="display:block;margin-bottom:8px;font-size:14px;color:#606266">请选择车牌颜色</label><select id="beidou-plate-type" style="width:100%;height:32px;border:1px solid #DCDFE6;border-radius:4px;padding:0 8px;font-size:14px"><option value="1">蓝色</option><option value="2">黄色</option><option value="3">黄绿色</option></select></div>',
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true
        });
        const sel = document.getElementById("beidou-plate-type");
        return sel ? sel.value : "1";
      } catch (error) {
        return "";
      }
    },
    /**
     * 关闭弹窗后重置表单，避免新增时沿用上一次编辑内容。
     */
    resetForm() {
      this.form = defaultForm();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    /**
     * 判断是否为后端返回的脱敏占位值。
     */
    isMaskedSecret(value) {
      return typeof value === "string" && value.indexOf("****") !== -1;
    },
    /**
     * 格式化关联业务名称。
     */
    formatBusinessNames(names) {
      return Array.isArray(names) && names.length ? names.join("、") : "-";
    },
    /**
     * 格式化时间戳。
     */
    formatTime(timestamp) {
      if (!timestamp || Number(timestamp) <= 1) return "-";
      return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  created() {
    this.loadData();
    this.loadBusinessOptions();
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-input__validateIcon {
  display: none;
}
</style>
